import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'store';
import { getHasChildrenSetupCompleted } from 'utils/user';

import { types } from './types';
import { login, logout } from './thunks';

const authStore = (store: RootState) => store?.auth;

const selectIsLoggedIn = createSelector(
  [authStore],
  (store) => store?.isLoggedIn ?? false
);

const selectAuthUser = createSelector([authStore], (store) => store?.user);

const selectIsGuestUser = createSelector(
  [authStore],
  (store) => store?.isGuestUser
);

const selectAuthUserRole = createSelector(
  [authStore],
  (store) => store?.user?.role
);

const selectHasChildrenSetupCompleted = createSelector(
  [selectAuthUser],
  getHasChildrenSetupCompleted
);

export {
  login,
  types,
  logout,
  selectAuthUser,
  selectIsLoggedIn,
  selectIsGuestUser,
  selectAuthUserRole,
  selectHasChildrenSetupCompleted,
};
